import React from 'react';

import {
  getBlockNumber,
} from '../util/web3Helpers';

class TimeRemaining extends React.Component {

  state = {
    amount: '...',
  };

  componentWillMount() {
    getBlockNumber().then(blockNumber => {

      let remainingBlocks = Number(this.props.blocks) - blockNumber;
      let amount;

      if (remainingBlocks <= 0) {
        amount = 'ENDED';
      } else if (remainingBlocks < 5) {
        amount = '< 1m';
      } else if (remainingBlocks < 10) {
        amount = '~ 1m';
      } else {
        amount = `~ ${Math.floor(remainingBlocks / 5)}m`;
      }

      this.setState({
        amount,
      });

    });
  }

  render() {
    return (
      <span>{this.state.amount}</span>
    );
  }

}

export default TimeRemaining;



// WEBPACK FOOTER //
// ./src/components/TimeRemaining.js